import { SITE } from "./site";

export const FLEET = [
  {
    name: "Executive Sedan",
    capacity: "Up to 3 passengers · 2 bags",
    examples: "Mercedes-Benz S-Class · Cadillac XTS · Lincoln Continental",
    image: SITE.sedanMercedes,
    perfect: "Airport transfers · Executive business travel · Daily rides",
  },
  {
    name: "Luxury SUV",
    capacity: "Up to 6 passengers · 5 bags",
    examples: "Cadillac Escalade · Lincoln Navigator · Chevrolet Suburban · GMC Yukon · Ford Expedition",
    image: SITE.suvLineup,
    perfect: "Family travel · Executive groups · VIP airport runs",
  },
  {
    name: "Stretch Limousine",
    capacity: "Up to 10 passengers",
    examples: "Lincoln Stretch · Chrysler 300 Stretch",
    image: SITE.heroFleet,
    perfect: "Weddings · Proms · Special celebrations",
  },
  {
    name: "Executive Van",
    capacity: "Up to 10 passengers",
    examples: "Ford Transit Executive · Mercedes Metris",
    image: SITE.vanFord,
    perfect: "Corporate groups · Tours · Wedding parties",
    whiteBg: true,
  },
  {
    name: "Sprinter Van",
    capacity: "Up to 14 passengers",
    examples: "Mercedes-Benz Sprinter · Executive Sprinter",
    image: SITE.sprinterBlack,
    perfect: "VIP groups · Wine tours · Corporate roadshows",
    whiteBg: true,
  },
  {
    name: "Shuttle Bus",
    capacity: "20–30 passengers",
    examples: "Executive Mini-coach · Grech GM45 Shuttle",
    image: SITE.coachExecutive,
    perfect: "Conferences · Weddings · Group events",
    whiteBg: true,
  },
  {
    name: "Motor Coach",
    capacity: "40–56 passengers",
    examples: "Full-size motor coach · Convention transport",
    image: SITE.motorCoach,
    perfect: "Conventions · Large weddings · School trips",
    whiteBg: true,
  },
];
